import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[modal-host]',
})

export class ModalContainerDirective {
  constructor(public viewContainerRef: ViewContainerRef) {

   }
}
